import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  public isMenuOpen = new BehaviorSubject(false);
  public isModalStarterFreeOpen = new BehaviorSubject(false);
  public features: { [key: string]: boolean } = {};
  constructor() {}

  public toggleMenu(nextVal = !this.isMenuOpen.value) {
    this.isMenuOpen.next(nextVal);
  }

  public toggleModalStarterFree(nextVal = !this.isModalStarterFreeOpen.value) {
    this.isModalStarterFreeOpen.next(nextVal);
  }

  public showFeature(feat: string) {
    if (feat in this.features) {
      return this.features[feat];
    }
    return false;
  }
}
